/**
 * Category type ID enum
 * @see https://github.com/stubhub/Viagogo.Site/blob/95a2b928647c78c65c66013040598611212280f1/Viagogo.Site.Services/Enumerations/Stubhub/CategoryType.cs
 */
export const CATEGORY_TYPE = {
  SPORTS_TEAM: 1,
  TOURNAMENT: 2,
  PARKING: 3,
  RIVALRY: 4,
  TOURING_PERFORMANCE: 6,
  SCHEDULE: 7,
  TOURNAMENT_PLAYOFF: 8,
  TOURNAMENT_POST_SEASON: 9,
  TOURNAMENT_SPRING_TRAINING: 10,
  SPORT_FRANCHISE: 11,
  TOURING_PERFORMANCE_CITY: 12,
  ARTIST: 13,
  BAND: 14,
  ATHLETE: 15,
  PERFORMER: 16,
  COMPETITION: 17,
  FESTIVAL: 18,
  SPORT: 19,
};
